import {OnSuccessFn} from "../sopi/hanko";
import {inject} from "@angular/core";
import {Router} from "@angular/router";

export const loginSucceessFn: OnSuccessFn = async () => {
    const router = inject(Router);

    await router.navigate(['/'], {
        replaceUrl: true,
        onSameUrlNavigation: 'reload',
    });

}